import React from 'react';

interface TimesheetOverviewProps {
    freelancerName: string;
    clientName: string;
    agentName: string;
    agentConsultantCode: string;
    timesheetDate: string;
    personnelReference: string;
    employerReference: string;
    clientReference: string;
    division: string;
    department: string;
}

export const TimesheetOverview: React.FC<TimesheetOverviewProps> = React.memo(
    ({
        freelancerName,
        clientName,
        agentName,
        agentConsultantCode,
        timesheetDate,
        personnelReference,
        employerReference,
        clientReference,
        division,
        department,
    }) => (
        <div className="timesheet-overview">
            <div className="timesheet-overview__row">
                <div className="timesheet-overview__item">
                    <span>Operative</span>
                    <strong>{freelancerName}</strong>
                </div>
                <div className="timesheet-overview__item">
                    <span>Client</span>
                    <strong>{clientName}</strong>
                </div>
                <div className="timesheet-overview__item">
                    <span>Agent</span>
                    <strong>{agentName}</strong>
                </div>
                <div className="timesheet-overview__item">
                    <span>Personnel Reference</span>
                    <strong>{personnelReference}</strong>
                </div>
                <div className="timesheet-overview__item">
                    <span>Client Reference</span>
                    <strong>{clientReference}</strong>
                </div>
                <div className="timesheet-overview__item">
                    <span>Consultant Code</span>
                    <strong>{agentConsultantCode}</strong>
                </div>
            </div>
            <div className="timesheet-overview__row timesheet-overview__row--secondary">
                <div className="timesheet-overview__item">
                    <span>Employer Reference</span>
                    <strong>{employerReference}</strong>
                </div>
                <div className="timesheet-overview__item">
                    <span>Division</span>
                    <strong>{division}</strong>
                </div>
                <div className="timesheet-overview__item">
                    <span>Department</span>
                    <strong>{department}</strong>
                </div>
                <div className="timesheet-overview__item">
                    <span>Timesheet Date</span>
                    <strong>{timesheetDate}</strong>
                </div>
            </div>
        </div>
    ),
);

TimesheetOverview.displayName = 'TimesheetOverview';

